import { createFileRoute } from '@tanstack/react-router';

import { FamilyHubGuardians } from '~features/family-hub/ui/family-hub-guardians';

const Component = () => {
  const { familyId } = Route.useParams();
  return <FamilyHubGuardians familyId={familyId} />;
};

export const Route = createFileRoute(
  '/_auth/_layout/families/$familyId/contacts',
)({
  component: Component,
});
